export default __webpack_public_path__ + "static/media/Grafico.e64eb8b5.png";